<template>
  <div>
    <table :height="this.windowSize.height-8" :max-height="this.windowSize.height-8" style="position: absolute;"
           width="100%">

      <tr height="48px" max-height="48px">

        <ContenidoBase
            :EstadoBtn="EstadoBtn"
            :descripcion="'Imprime el análisis de ventas de productos'"
            :titulo="'Reporte análisis de ventas de productos'"
            @MethodAnular="anular"
            @MethodEliminar="remove"
            @MethodGuardar="save"
            @MethodImprimir="imprimirList"
            @MethodNuevo="newwnuevo"
            @abrirBarraTablaDinamica="abrirTabla"

        />
      </tr>


      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height-96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn
                        color="yellow accent-4"
                        small
                        @click.prevent="actualiza_tb_ver"
                    >
                      <i class="fa fa-eye" style="font-size: 25px;"> </i> ver
                    </v-btn
                    >
                    <v-btn
                        color="deep-purple accent-2"
                        dark
                        small
                        @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px;"> </i>
                      Listado
                    </v-btn
                    >
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReportesAnalisisVentasProductos'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>


          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">
          <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
            <!-- Formulario-Reporte analisis de ventas de productos -->

            <v-container>
              <v-card color="grey lighten-3">

                <v-toolbar
                    color="#BDBDBD"
                    dense
                    flat
                    style="border: 1px solid #000000;"
                >


                  <v-avatar size="45" tile>
                    <img
                        alt="Reporte"
                        src="@/assets/iconos_micromarket/custom-reports.png"
                    >
                  </v-avatar>
                  <span class="font-weight-light"
                        style="font-size: 20px;"> Reporte análisis de ventas de productos </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr>

                <v-container style="border: 1px solid #000000;">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">


                        <!-- -----------------------------  desde  -->
                        <v-text-field
                            v-model="AnalisisVentas.desde"
                            :rules="[$rules.required]"
                            dense
                            label="Desde:"
                            outlined
                            type="date"
                            @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                            v-model="AnalisisVentas.almacen"
                            :items="Ralmacen"
                            autocomplete="off"
                            dense
                            item-text="descripcion"
                            label="Almacén"
                            outlined
                            required
                            @blur="SelctCbAlmacen"
                            @focus="CargarRalmacen"
                        >
                          <template v-slot:prepend>
                            <v-img
                                height="20px"
                                src="../../assets/warehouse.png"
                                width="20px"
                            ></v-img>
                          </template>
                        </v-combobox>

                        <v-combobox
                            v-model="AnalisisVentas.departamento"
                            :items="RDepartamento"
                            autocomplete="off"
                            dense
                            item-text="descripcion"
                            label="Departamento:"
                            outlined
                            @blur="SelctCbDesc"
                            @focus="cargarDepartamento"
                        >
                          <template v-slot:prepend>
                            <i
                                class="fa fa-building"
                                style="font-size: 20px; width: 20px"
                            ></i>
                          </template>
                        </v-combobox>

                        <v-autocomplete v-model="AnalisisVentas.documento"
                                        :item-text="item => `${item.nombrecorto.trim()} - ${item.descripcion}`"
                                        :items="documentoList"
                                        clearable dense label="Documento"
                                        outlined return-object @focus.once="findAllDocumentos">
                          <template #prepend>
                            <i class="fa fa-book" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-autocomplete>

                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">

                        <!-- -----------------------------  Hasta  -->
                        <v-text-field
                            v-model="AnalisisVentas.hasta"
                            :rules="[$rules.required]"
                            dense
                            label="Hasta:"
                            outlined
                            type="date"
                            @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px;"></i>
                          </template>
                        </v-text-field>

                        <!-------------------------------------------------- Producto -->
                        <v-combobox
                            v-model="AnalisisVentas.producto"
                            :items="Rproducto"
                            autocomplete="off"
                            dense
                            item-text="productos.descripcion"
                            label="Productos:"
                            outlined
                            @blur="SelctCbProduc"
                            @focus="CargarRproducto"
                            @keyup="CbFilProducto">
                          <template v-slot:prepend>
                            <i
                                class="fa fa-shopping-cart"
                                style="font-size: 20px;"
                            ></i>
                          </template>
                        </v-combobox>

                        <v-combobox
                            v-model="AnalisisVentas.fabricante"
                            :items="RFabricante"
                            autocomplete="off"
                            dense
                            item-text="nombre"
                            label="Fabricante:"
                            outlined
                            @blur="SelctCbFabricante"
                            @focus="CargarFabricante"
                        >
                          <template v-slot:prepend>
                            <i
                                class="fa fa-wrench"
                                style="font-size: 20px;"
                            ></i>
                          </template>
                        </v-combobox>

                      </v-col>
                      <!-- fn columna 2 -->

                    </v-row>

                  </v-form>
                </v-container>

                <hr>
                <ModalReporteFiltros
                    :Datos="AnalisisVentas"
                    @DataReporteBasico="DDataReporteBasico"
                />

              </v-card>
            </v-container>
            <!-- fn Formulario-Reporte analisis de ventas de productos -->
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height-96" width="109">

          <div class="overflow-y-auto "
               v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">

            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->

      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
        v-model="acti_tb_data"
        label="myAlert"
        max-height="100%"
        max-width="100%"
        persistent
        transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px;"> </i>

          <v-spacer></v-spacer>
          <v-btn
              color="grey darken-4"
              fab
              small
              @click="acti_tb_data = !acti_tb_data"
          >
            <i class="fa fa-close" style="font-size: 20px; color:#dd4b39;"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                  v-model="search"
                  hide-details
                  label="Buscar"
                  single-line
                  @keyup="filtro"
              >
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px;"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
                :headers="slotHtabla"
                :items="list"
                :search="search"
                dense
                @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
        v-model="Elim_notif.estado"
        label="myAlert"
        max-width="350"
        persistent
        transition="fab-transition"
    >
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px;"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px;"></i>
          </h4>
        </v-card-title>
        <hr/>

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr/>
        <v-card-actions>
          <v-btn
              small
              @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
          >
            <i class="fa fa-check" style="font-size: 20px;"></i> Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px;"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
        v-model="aalert.estado"
        :color="aalert.color"
        :timeout="120000"
        :vertical="true"
        style="margin-top: 20%;"
        top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import {EventBus} from "../../event-bus"
import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
import ContenidoBase from "../../components/ContenidoBase"
import ModalReporteFiltros from "../../components/ModalReporteFiltros2"
import {
  currencyFormatter,
  fechaNueva,
  FormatoFecha,
  getParamFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoBasico,
  RedondeoValor,
  RedondeoValorCantRed,
} from "@/js/Funciones.js"

export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros,
  },
  created() {
    var json = {

      titulo: "Reporte análisis de ventas de productos",
      descripcion: "Imprime el análisis de ventas de productos",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [
        "ReportesAnalisisVentasProductosNew",
        "ReportesAnalisisVentasProductosSave",
        "ReportesAnalisisVentasProductosRemove",
        "ReportesAnalisisVentasProductosAnular",
        "ReportesAnalisisVentasProductosPrintList",
      ],
    }
    EventBus.$emit("anularBotonesAccion", json)
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReportesAnalisisVentasProductosNew", this.new)
    // EventBus.$on("ReportesAnalisisVentasProductosSave", this.save);
    // EventBus.$on("ReportesAnalisisVentasProductosRemove", this.remove);
    // EventBus.$on("ReportesAnalisisVentasProductosAnular", this.remove);
    // EventBus.$on("ReportesAnalisisVentasProductosPrintList", this.imprimirList);
    EventBus.$on("emitReportesAnalisisVentasProductos", this.datostabla)
    this.cargarTodo()

    EventBus.$on("onResize", this.onResize)
  },

  data: () => ({

    Rpropietario: [],
    RSucursal: [],
    RCaja: [],
    Ralmacen: [],
    Rproducto: [],
    RDepartamento: [],
    RFabricante: [],
    documentoList: [],

    ListaTiposClientes: [],
    windowSize: {width: "auto", height: "auto"},
    AnalisisVentas: {

      nombre: "REPORTE ANÁLISIS DE VENTAS DE PRODUCTOS",
      UrlImprimir: "/reportes-pv/ImprimirListAnalisisVentasProductos",
      UrlExel: "/reportes-pv/ExcelListAnalisisVentasProductos",
      UrlCorreo: "/reportes-pv/CorreoListAnalisisVentasProductos",
      desde: fechaNueva(),
      hasta: fechaNueva(),
      almacen: null,
      producto: null,
      departamento: null,
      fabricante: null,
      documento: null,

      //fechaCreacion: new,
      //  fechaModificacion: "", 
    },

    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: false,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: false,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },

    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{text: "Tipo Clientes", value: "descripcion"}],

    slotlist: [
      {dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:"},
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:",
      },
      {dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo"},
    ],

    slotHtabla: [
      {text: "Código", value: "codigo"},
      {text: "Descripcion", value: "descripcion"},
    ],

    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?",
    },

    aalert: {
      estado: false,
      color: null,
    },

  }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
    currencyFormatter,
    FormatoFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoValor,
    RedondeoBasico,
    RedondeoValorCantRed,
    fechaNueva,
    getParamFecha,

    ver() {

      console.log("Ver ver ver")

      var jsn = {
        usuario: {
          userid: "bibbia", passwd: "", jdbcJDNI: "", sudo: true,
          dashboard: true, micromarket: false, transportnet: false, gubernamental: false, verVentasCaja: false,
        },
        datos: JSON.parse(JSON.stringify(this.registro)),
      }

      this.$axios.post("http://10.0.0.95:8080/ReportServicios/services/reportes/findallUsuario",
          JSON.parse(JSON.stringify(jsn)))
          //  .then(res => this.alerta(res.data.mensage,res.data.estado))
          .then(res => {
            this.alerta("Dato Guardado correctamente", "bien"), console.log(res.data)
          })
          .catch(error => this.alerta(error, "error"))


    },


    onResize(e) {

      console.log("imprii ")

      console.log(e)
      this.windowSize = e


    },

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir

    },
    async cargarTodo() {

    },
    datostabla(e) {

      this.AnalisisVentas = e
      this.acti_tb_data = false
    },
    save() {
    },
    remove() {
    },
    eliminar() {
    },
    anular() {
    },
    imprimirList() {
    },
    //retorna los datos del componente ModalReporteFiltros
    DDataReporteBasico() {
    },


    SelctCbFabricante() {
      if (this.AnalisisVentas.fabricante == null) {

        this.AnalisisVentas.fabricante = ""
      }

      if (this.AnalisisVentas.fabricante.codigo == undefined) {

// this.alerta("Seleccione un fabricante", "error");
        this.AnalisisVentas.fabricante = ""
        return

      }

    },


    CargarFabricante() {
      this.$axios
          .get(
              this.$hostname + this.$hName + "/fabricante/activo",
              {
                headers: this.$store.getters.GetheadersAxios,
              },
          ).then(res => this.RFabricante = res.data)
          .catch()
    },
    newwnuevo() {
      (this.AnalisisVentas = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: "",
      }),
          EventBus.$emit("actualizaBarraBusqueda2")
    },


// Realizar una solicitud GET al servidor y devolver los datos al Vue HTML.
    CargarRalmacen() {


      this.$axios
          .get(this.$hostname + this.$hName + "/almacen/activos",
              {headers: this.$store.getters.GetheadersAxios},
          )
          .then(res => {
            this.Ralmacen = res.data
          })

    },

// Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbAlmacen() {
      if (this.AnalisisVentas.almacen == null) {
        this.AnalisisVentas.almacen = ""
      }

      if (this.AnalisisVentas.almacen.codigo == undefined) {
        this.alerta("Seleccione un Almacén", "error")
        this.AnalisisVentas.almacen = ""
        return
      }
    },


    // Comprobando si el producto es nulo o indefinido.
    SelctCbProduc() {
      if (this.AnalisisVentas.producto == null) {
        this.AnalisisVentas.producto = ""
      }

      if (this.AnalisisVentas.producto.productos == undefined) {
        this.alerta("Seleccione un producto", "error")
        this.AnalisisVentas.producto = ""
        return
      }
    },


// Hacer una llamada API al servidor y obtener los datos.
    CargarRproducto() {

      this.$axios.get(this.$hostname + this.$hName +
          "/unidades-productos/*/false/buscar",
          {headers: this.$store.getters.GetheadersAxios},
      ).then(res => {
        this.Rproducto = res.data
      })

    },


// Realizar una llamada API al servidor y devolver los datos al componente Vue.
    CbFilProducto(e) {
      //console.log(e.target.value)
      if (e.target.value.length >= 3) {

        this.$axios
            .get(this.$hostname +
                this.$hName +
                "/unidades-productos/" + e.target.value.trim().replaceAll("/", "*-S-*") + "/false/buscar",
                {headers: this.$store.getters.GetheadersAxios},
            )
            .then(res => {
              this.Rproducto = res.data
            })
      }
    },


// Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
    BlurDesde() {

      if (this.AnalisisVentas.desde.toString().length == 0) {
        this.AnalisisVentas.desde = this.fechaNueva()
      }

    },

// Establecer la fecha a la fecha de hoy si el usuario no ha ingresado una fecha.
    BlurHasta() {

      if (this.AnalisisVentas.hasta.toString().length == 0) {
        this.AnalisisVentas.hasta = this.fechaNueva()
      }

    },


    cargarDepartamento() {

      this.$axios
          .get(
              this.$hostname + this.$hName + "/departamento/activo",
              {
                headers: this.$store.getters.GetheadersAxios,
              },
          ).then(res => this.RDepartamento = res.data)
          .catch(error => {
            if (error.response) {
              this.alerta(error.response.request.responseText, "error")
            } else {
              this.alerta(error, "error")
            }
          })
    },
    SelctCbDesc() {
      // producto:null,
      //     departamento:null,

      if (this.AnalisisVentas.departamento == null) {
        this.AnalisisVentas.departamento = ""
      }

      if (this.AnalisisVentas.departamento.codigo == undefined) {
        //this.alerta("Seleccione un departamento", "error");
        this.AnalisisVentas.departamento = ""
        return
      }
    },


    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e)

        this.newwnuevo()
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e)

        this.ejecucion = false
      }
    },


    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data
      this.filtro()
    },

    async filtro() {

    },

    findAllDocumentos() {
      this.$axios
          .get(
              this.$hostname + this.$hName + "/documentoventas/findall",
              {
                headers: this.$store.getters.GetheadersAxios,
              },
          ).then((res) => {
        this.documentoList = res.data
      })
          .catch(error => {
            console.error(error)
          })
    },
  },
}
</script>

<style></style>
